import React from 'react';
import { Reveal } from '../components/Reveal';
import { Mail } from 'lucide-react';
import { trackLandingCTA } from '@/lib/analytics';

export const FIRM_CONTACT_HREF =
  'mailto:support@mendllabs.ai?subject=Design%20partner%20%E2%80%94%20running%20money%20for%20others';

/**
 * "Running money for others?" -- marketing ruling M1 (2026-10-20): one
 * invitation block for firms, nothing to buy, no "verified record" (the
 * design-partner invitation itself is on the counsel list, M1(5)(g)).
 */
export const FirmInvite: React.FC = () => {
  return (
    <section id="firms" className="py-20 px-6 scroll-mt-20">
      <Reveal
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-[900px] mx-auto rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 md:p-10"
      >
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">
          Running money for others?
        </h2>
        <p className="text-white/55 leading-relaxed mb-6">
          We are looking for ten small firms to work with as design partners while we build
          the record layer: a signed mandate, deterministic limits, a daily-reconciled ledger
          and an exportable record. There is nothing to buy yet. The ask is one thirty-minute
          call and one paper mandate, and that you tell us what is missing.
        </p>
        <a
          href={FIRM_CONTACT_HREF}
          onClick={() => trackLandingCTA('firm')}
          className="inline-flex items-center gap-2 rounded-lg border border-white/10 px-5 py-2.5 text-sm font-medium text-white hover:bg-white/5 transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2dd4a0]"
        >
          <Mail size={16} />
          Write to support@mendllabs.ai
        </a>
      </Reveal>
    </section>
  );
};
